export default __webpack_public_path__ + "static/media/Minicard_2d.c557b52a.svg";